// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2nw1V","item":"PaymentsMobile_item__xb90b","label":"PaymentsMobile_label__3ANgA","amount":"PaymentsMobile_amount__3aR3I"};